<template>
  <div class="news">
    <Detail v-if="item" :item="item" />
    <div v-else v-for="(item) in activeList" :key="item.id" class="item">
      <div class="item-left" @click="handleDetail(item.id)">
        <img :src="`http://tarzan.minus.live${item.img}`"/>
      </div>
      <div class="item-right">
        <div class="item-right-time">{{item.config.time}}</div>
        <div class="item-right-title" @click="handleDetail(item.id)">{{item.name}}</div>
        <div class="item-right-new" @click="handleDetail(item.id)">
          {{item.config.content}}
        </div>
        <div class="item-right-btn" @click="handleDetail(item.id)">阅读全文</div>
      </div>
    </div>

    <div class="pagination">
      <div :class="getPageClasses(i)" v-for="(page, i) in pages" :key="i" @click="handleClick(i)">
        {{i + 1}}
      </div>
    </div>
  </div>
</template>

<script>
import Detail from './detail'
import { getNewsList } from '../../services'

export default {
  name: 'news',
  components: {
    Detail
  },

  data () {
    return {
      list: [],
      item: null,
      page: 0,
      pages: 0,
      activeList: []
    }
  },

  created () {
    const id = this.$route.query.id
    getNewsList().then(res => {
      if (id) {
        res.data.data.data.children.forEach(item => {
          if (item.id == id) {
            this.item = {
              ...item,
              config: JSON.parse(item.config)
            }
          }
        })
      } else {
        this.list = res.data.data.data.children.map(item => {
          return {
            ...item,
            config: JSON.parse(item.config)
          }
        })

        this.activeList = this.list.slice(0, 5)

        this.pages = Math.ceil(res.data.data.data.children.length / 5)
      }
    })
  },

  methods: {
    handleDetail (id) {
      // this.$router.push(`/news/${id}`)
      let routeUrl = this.$router.resolve({
        path: "/news",
        query: { id }
      });
      window.open(routeUrl .href, '_blank');
    },

    handleClick (page) {
      this.activeList = this.list.slice(page * 5, (page + 1) * 5)
      this.page = page
    },

    getPageClasses (i) {
      if (i === this.page) {
        return 'active'
      }
      return ''
    }
  }
}
</script>

<style lang="less">
  .news {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .item {
      position: relative;
      padding: 30px 0px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #999;
      @media (min-width: 1280px) and (max-width: 1680px){
        padding: 45px 0px;
      }
            
      @media screen and (min-width: 1920px){
        padding: 60px 0px;
      }
      &-left {
        img {
          width: 222px;
          height: auto;
          transform-origin: 50% 50%;
          transition: all .5s ease-in-out;
        }

        @media (min-width: 1280px) and (max-width: 1680px){
          width: 333px;
        }
              
        @media screen and (min-width: 1920px){
          width: 444px;
        }
      }

      &-left:hover {
        img {
          transform: scale(1.2)
        }
      }

      &-right {
        width: 600px;
        margin-left: 10px;
        padding: 0 30px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        @media (min-width: 1280px) and (max-width: 1680px){
          width: 900px;
          padding: 0px 45px;
          margin-left: 15px;
        }
              
        @media screen and (min-width: 1920px){
          width: 1200px;
          padding: 0px 60px;
          margin-left: 20px;
        }

        &-time {
          color: #999;
          margin-bottom: 30px;
          font-size: 10px;

          @media (min-width: 1280px) and (max-width: 1680px){
            font-size: 15px;
          }
                
          @media screen and (min-width: 1920px){
            font-size: 20px;
          }
        }

        &-title {
          color: #444;
          margin-bottom: 30px;
          font-size: 16px;
          font-weight: 200;
          cursor: pointer;

          @media (min-width: 1280px) and (max-width: 1680px){
            font-size: 24px;
          }
                
          @media screen and (min-width: 1920px){
            font-size: 32px;
          }
        }

        &-new {
          display: -webkit-box;
          font-size: 10px;
          color: #444;
          overflow: hidden; 
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          line-height: 20px;
          text-align: left;
          cursor: pointer;

          @media (min-width: 1280px) and (max-width: 1680px){
            font-size: 15px;
          }
                
          @media screen and (min-width: 1920px){
            font-size: 20px;
          }
        }

        &-btn {
          position: absolute;
          font-size: 10px;
          color: #444;
          bottom: 20px;
          right: 20px;
          cursor: pointer;

          @media (min-width: 1280px) and (max-width: 1680px){
            font-size: 15px;
          }
                
          @media screen and (min-width: 1920px){
            font-size: 20px;
          }
        }
      }
    }

    .pagination {
      display: flex;
      margin-top: 20px;
      > div {
        padding: 10px;
        cursor: pointer;
      }

      .active {
        color: #f45936;
      }
    }
  }
</style>